import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import "@/seo/seo.css";

import router from "./router";
import store from "./store";

// importing vuetify
import '@mdi/font/css/materialdesignicons.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import vuetify from "./plugins/vuetify"

import VueTelInputVuetify from 'vue-tel-input-vuetify/lib';
Vue.use(VueTelInputVuetify, {vuetify});

import Logo from '@/components/main/logo'
Vue.component('logo', Logo)


import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
Vue.use(Viewer)


window.apiUrl = process.env.NODE_ENV === "production" ? process.env.VUE_APP_PRODUCTION_API_URL : process.env.VUE_APP_API_URL;
import axios from 'axios'
axios.defaults.baseURL = window.apiUrl;
axios.defaults.headers.common['App-Platform'] = process.env.VUE_APP_PLATFORM;
axios.defaults.headers.common['App-Version'] = process.env.VUE_APP_VERSION;

window.axios = axios

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
